import React from 'react';

import classes from './ScoringRuleItem.module.scss';
import { RichTextViewer } from '../../../../../../../shared/features/rich-text';
import { ScoringRuleItemType } from '../../../../../../interfaces/leaderboard/ScoringRuleItemType';

type ScoringRuleItemProps = {
  item: ScoringRuleItemType;
};

const ScoringRuleItem = ({ item }: ScoringRuleItemProps) => {
  return (
    <div className={classes.container}>
      {item.title && <div className={classes.title}>{item.title}</div>}
      <RichTextViewer content={item.content} />
      {item.note && <div className={classes.note}>{item.note}</div>}
    </div>
  );
};

export { ScoringRuleItem };
